var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendeStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0843 5.21L17.4943 8.02999C17.6843 8.41999 18.1943 8.78999 18.6243 8.86999L21.1743 9.28999C22.8043 9.55999 23.1843 10.74 22.0143 11.92L20.0243 13.91C19.6943 14.24 19.5043 14.89 19.6143 15.36L20.1843 17.82C20.6343 19.76 19.5943 20.52 17.8843 19.5L15.4943 18.08C15.0643 17.82 14.3443 17.82 13.9143 18.08L11.5243 19.5C9.81427 20.51 8.77429 19.76 9.22429 17.82L9.79429 15.36C9.90429 14.9 9.71429 14.25 9.38429 13.91L7.3943 11.92C6.2243 10.75 6.6043 9.56999 8.2343 9.28999L10.7843 8.86999C11.2143 8.79999 11.7243 8.41999 11.9143 8.02999L13.3243 5.21C14.0743 3.68 15.3143 3.68 16.0843 5.21Z",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69531 5H2.69531",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 19H2.69531",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69531 12H2.69531",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeStar);
export default __webpack_public_path__ + "static/media/attende-star.0f8bb20761d23e2a430f2cbc8a7861e1.svg";
export { ForwardRef as ReactComponent };